import script from "./SettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsPage.vue?vue&type=style&index=0&id=62dd4d7e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62dd4d7e"]])

export default __exports__